export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1699547283492-7a8b85165edd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHx3aGVlbGNoYWlyJTIwZG9uYXRpb24lMjBpbmRpYXxlbnwwfHx8fDE3OTA2NzUyMDZ8MA&ixlib=rb-4.1.0&q=85",
  wheelchair: "https://images.unsplash.com/photo-1527348696784-c3ff7c1453f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHx3aGVlbGNoYWlyJTIwZG9uYXRpb24lMjBpbmRpYXxlbnwwfHx8fDE3OTA2NzUyMDZ8MA&ixlib=rb-4.1.0&q=85",
  medical: "https://images.unsplash.com/photo-1779006277040-67543ea167b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxkb2N0b3IlMjBwYXRpZW50JTIwaW5kaWF8ZW58MHx8fHwxNzkwNjc1MjI0fDA&ixlib=rb-4.1.0&q=85",
  volunteers: "https://images.unsplash.com/photo-1560220604-1985ebfe28b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB2b2x1bnRlZXJzJTIwY2hhcml0eSUyMGV2ZW50fGVufDB8fHx8MTc5MDY3NTIwNnww&ixlib=rb-4.1.0&q=85",
  gallery1: "https://images.unsplash.com/photo-1596450514537-fae68a81346b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjaGFyaXR5JTIwaGVscGluZyUyMGRpc2FibGVkJTIwcGVyc29ufGVufDB8fHx8MTc5MDY3NTIwNnww&ixlib=rb-4.1.0&q=85",
  gallery2: "https://images.unsplash.com/photo-1598893669025-978f0411b0f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjaGFyaXR5JTIwaGVscGluZyUyMGRpc2FibGVkJTIwcGVyc29ufGVufDB8fHx8MTc5MDY3NTIwNnww&ixlib=rb-4.1.0&q=85",
};

export const TRUST = {
  name: "શ્રી યુનિક વિકલાંગ ચેરિટેબલ ટ્રસ્ટ",
  shortName: "SUVCT",
  tagline: "સેવા પરમો ધર્મ",
  upiId: "",
  bank: {
    name: "Shree Unique Viklang Charitable Trust",
    bankName: "YES BANK",
    account: "117794600000072",
    ifsc: "YESBOCMSNOC",
    branch: "રાજકોટ, ગુજરાત",
  },
  contact: {
    phones: ["+91 92778 07778", "+91 99988 90039"],
    email: "suvctrust2@gmail.com",
    address: "શાળા નં. 55, આનંદનગર, બગીચા સામે, રાજકોટ, ગુજરાત",
    regNo: "E/7950",
    csr: "CSR00058798",
    tax: "80G કરમુક્તિ લાભયોગ્ય",
  },
  facebook: "https://www.facebook.com/shailesh.pandya.16568",
  instagram: "https://www.instagram.com/shailesh.pandya.16568/",
  siteUrl: "https://uniqueviklangtrust.org",
  whatsappChat: "https://wa.me/919277807778?text=%E0%AA%A8%E0%AA%AE%E0%AA%B8%E0%AB%8D%E0%AA%A4%E0%AB%87%2C%20%E0%AA%AE%E0%AA%A8%E0%AB%87%20%E0%AA%9F%E0%AB%8D%E0%AA%B0%E0%AA%B8%E0%AB%8D%E0%AA%9F%20%E0%AA%B5%E0%AA%BF%E0%AA%B6%E0%AB%87%20%E0%AA%AE%E0%AA%BE%E0%AA%B9%E0%AB%80%E0%AA%A4%E0%AB%80%20%E0%AA%9C%E0%AB%8B%E0%AA%88%E0%AA%8F%20%E0%AA%9B%E0%AB%87",
};

export const NAV_LINKS = [
  { id: "about", label: "અમારા વિશે" },
  { id: "programs", label: "કાર્યક્રમો" },
  { id: "events", label: "ઇવેન્ટ્સ" },
  { id: "gallery", label: "ઝલક" },
  { id: "media", label: "મીડિયામાં અમે" },
  { id: "donate", label: "દાન કરો" },
  { id: "join", label: "જોડાઓ" },
];

export const MARQUEE_WORDS = [
  "સેવા પરમો ધર્મ",
  "સમર્પણ",
  "સ્વાવલંબન",
  "સહાનુભૂતિ",
  "સન્માન",
  "આશા",
];

export const IMPACT_STATS = [
  { value: 17, suffix: "+", label: "વર્ષની નિ:સ્વાર્થ સેવા" },
  { value: 39, suffix: "", label: "રાષ્ટ્રીય સ્તરે મેડલ" },
  { value: 1000, suffix: "+", label: "નોંધાયેલા દિવ્યાંગ સભ્યો" },
  { value: 21, suffix: "", label: "દિવ્યાંગતાની કેટેગરી સુધી સેવા" },
];

export const PROGRAMS = [
  {
    id: "aids",
    title: "નિ:શુલ્ક સાધન સહાય",
    desc: "દાતાઓની મદદથી ટ્રાયસાયકલ, વ્હીલચેર, બૈસાખી, લાકડી અને હિયરિંગ એઇડ મફત આપી દિવ્યાંગ બંધુઓને સ્વાવલંબી બનાવીએ છીએ.",
    image: IMAGES.wheelchair,
    big: true,
  },
  {
    id: "medical",
    title: "નિ:શુલ્ક તબીબી સહાય",
    desc: "દર ગુરુવારે મફત તબીબી તપાસ અને દવા કેમ્પ, તથા મફત મોતિયાના ઓપરેશન.",
    image: IMAGES.medical,
  },
  {
    id: "education",
    title: "શિક્ષણ અને રોજગાર સહાય",
    desc: "ફી, પુસ્તકો, મફત કોમ્પ્યુટર તાલીમ અને નોકરી-સ્વરોજગાર માટે સંપૂર્ણ માર્ગદર્શન.",
  },
  {
    id: "sports",
    title: "યુનિક પેરા સ્પોર્ટ્સ ક્લબ",
    desc: "1 આંતરરાષ્ટ્રીય અને 39 રાષ્ટ્રીય મેડલ જીતનાર ખેલાડીઓનું ક્લબ — તાલીમ, સાધનો અને સપ્લિમેન્ટની વ્યવસ્થા.",
  },
  {
    id: "food",
    title: "માસિક અનાજ સહાય",
    desc: "નબળી આર્થિક સ્થિતિ ધરાવતા દિવ્યાંગ પરિવારોને દર મહિને મફત અનાજ.",
  },
];

export const DONATION_PRESETS = [
  { amount: 101, impact: "દૈનિક સેવા-કાર્યમાં સીધો સહભાગ" },
  { amount: 501, impact: "એક પરિવાર માટે માસિક અનાજ કીટ" },
  { amount: 1100, impact: "દવા અને તબીબી સહાય" },
  { amount: 5100, impact: "એક વ્હીલચેર કે ટ્રાયસાયકલ" },
];

export const MEDIA = [
  { src: "/media/khel-mahakumbh.jpeg", title: "ખેલ મહાકુંભમાં ટ્રસ્ટના દિવ્યાંગોનું શ્રેષ્ઠ પ્રદર્શન — ૧૩૬ મેડલ", tag: "અખબારી યાદી" },
  { src: "/media/national-medals.jpeg", title: "રાષ્ટ્રીય કક્ષાએ ૩ ગોલ્ડ, ૨ સિલ્વર અને ૧ બ્રોન્ઝ મેડલ", tag: "અખબારી યાદી" },
  { src: "/media/yojana-margdarshan.jpeg", title: "દિવ્યાંગો માટે સરકારી યોજનાઓ અંગે નિ:શુલ્ક માર્ગદર્શન", tag: "અખબારી યાદી" },
  { src: "/media/maa-amrutam.jpeg", title: "૧૭૬ દિવ્યાંગોને મા અમૃતમ અને મા વાત્સલ્ય કાર્ડ અપાયા", tag: "અખબારી યાદી" },
  { src: "/media/kaushalya.jpeg", title: "દિવ્યાંગોનું કૌશલ્ય ખિલવતું યુનિક વિકલાંગ ટ્રસ્ટ", tag: "અખબારી યાદી" },
  { src: "/media/mahapatang.jpeg", title: "૧૦૦૦ 'યુનિક' દિવ્યાંગો સાથે મહાપતંગ મહોત્સવ", tag: "અખબારી યાદી" },
];

export const GALLERY = [
  { src: "/photos/group.jpeg", caption: "ટ્રસ્ટ પરિવાર સાથે", cat: "events" },
  { src: "/photos/sports.jpeg", caption: "પેરા સ્પોર્ટ્સ સ્પર્ધા", cat: "sports" },
  { src: "/gallery/sports-2.jpeg", caption: "રાષ્ટ્રીય મેડલ વિજેતા", cat: "sports" },
  { src: "/gallery/sports-3.jpeg", caption: "મેડલ અને પ્રમાણપત્ર સાથે ગૌરવ", cat: "sports" },
  { src: "/gallery/sports-4.jpeg", caption: "અમારી ચેમ્પિયન દિકરી", cat: "sports" },
  { src: "/gallery/sports-5.jpeg", caption: "ગોલ્ડ મેડલ વિજેતા", cat: "sports" },
  { src: "/gallery/sports-6.jpeg", caption: "સ્ટેટ લેવલ વિજેતા", cat: "sports" },
  { src: "/photos/event.jpeg", caption: "ખેલ મહાકુંભ ઉત્સવ", cat: "events" },
  { src: "/gallery/events-2.jpeg", caption: "ફન ક્લબ ઉત્સવ", cat: "events" },
  { src: "/gallery/events-3.jpeg", caption: "નૃત્ય અને આનંદ", cat: "events" },
  { src: "/gallery/events-4.jpeg", caption: "હરિદ્વાર યાત્રા", cat: "events" },
  { src: "/gallery/events-5.jpeg", caption: "સ્ટેજ કાર્યક્રમ", cat: "events" },
  { src: "/gallery/events-6.jpeg", caption: "યાત્રા પ્રસંગે સમૂહ", cat: "events" },
  { src: "/gallery/events-7.jpeg", caption: "પ્રવાસ — પવિત્ર સ્થળે", cat: "events" },
  { src: "/gallery/events-8.jpeg", caption: "ફન ક્લબ પ્રવાસ", cat: "events" },
  { src: "/gallery/events-9.jpeg", caption: "બસ પ્રવાસની મજા", cat: "events" },
  { src: "/gallery/events-10.jpeg", caption: "સ્નેહમિલન", cat: "events" },
  { src: "/gallery/medical-1.jpeg", caption: "નિ:શુલ્ક તબીબી કેમ્પ", cat: "medical" },
  { src: "/gallery/medical-2.jpeg", caption: "ફિઝિયોથેરાપી સારવાર", cat: "medical" },
  { src: "/gallery/medical-3.jpeg", caption: "આરોગ્ય તપાસ", cat: "medical" },
  { src: "/gallery/medical-4.jpeg", caption: "ગુરુવારનો મેડિકલ કેમ્પ", cat: "medical" },
  { src: "/gallery/aid-1.jpeg", caption: "મા અમૃતમ કાર્ડ વિતરણ", cat: "aid" },
  { src: "/gallery/aid-2.jpeg", caption: "કીટ અને સાધન વિતરણ", cat: "aid" },
  { src: "/gallery/aid-3.jpeg", caption: "અનાજ કીટ વિતરણ", cat: "aid" },
  { src: "/photos/foodkit.jpeg", caption: "માસિક અનાજ કીટ", cat: "aid" },
  { src: "/gallery/aid-4.jpeg", caption: "વ્હીલચેર સહાય", cat: "aid" },
  { src: "/gallery/aid-5.jpeg", caption: "વ્હીલચેર સાથે સ્વાવલંબન", cat: "aid" },
  { src: "/gallery/aid-6.jpeg", caption: "મફત કોમ્પ્યુટર તાલીમ", cat: "aid" },
];
